import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { MapContext } from 'contexts/MapContext';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import Directions from './Directions';

const useStyles = makeStyles({
  pointer: {
    cursor: 'pointer',
  },
  backArrowFlex: {
    display: 'flex',
    fontSize: '16px',
    width: '80%',
    margin: '15px',
  },
  header: {
    fontFamily: 'Montserrat',
    fontSize: '20px',
    fontWeight: '700',
    lineHeight: '24px',
    letterSpacing: '0px',
    textAlign: 'left',
    marginLeft: '15px',
  },
  root: {
    borderRadius: '20px',
    margin: '1vh 1vw',
  },
  media: {
    height: 150,
    background: 'center',
    backgroundSize: 'cover',
  },
  subheader: {
    fontFamily: 'Open Sans',
    fontWeight: '600',
    lineHeight: '20px',
    fontSize: '14px',
    letterSpacing: '0.25px',
    /* identical to box height, or 143% */
  },
  managerFlex: {
    display: 'flex',
    flexDirection: 'column',
    fontFamily: 'Open Sans',
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: '0.25px',
    color: '#4D4D4D',
    margin: '25px',
  },
  websiteAttr:{
    marginTop: '10px',
    color: '#4D7343',
  },
  poiTitle: {
    fontFamily: 'Montserrat',
    fontSize: '20px',
    fontStyle: 'normal',
    fontWeight: '700',
    lineHeight: '24px',
    letterSpacing: '0px',
    textAlign: 'left',
  },
  managerTitle: {
    color: '#4D4D4D',
    fontFamily: 'Open Sans',
    fontWeight: '300',
    fontSize: '14px',
    lineHeight: '16.8px',
    letterSpacing: '0.25px',
  },
  favoriteFlex: {
    display: 'flex',
    flexDirection: 'column',
    color: '#4D7343',
    fontFamily: 'Open Sans',
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '16px',
    letterSpacing: '0.4px',
    alignItems: 'center',
  },
  directionsFlex: {
    display: 'flex',
    flexDirection: 'column',
    color: '#4D7343',
    fontFamily: 'Open Sans',
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '16px',
    letterSpacing: '0.4px',
    alignItems: 'center',
    height: '25px',
  },
  descriptionText: {
    fontFamily: 'Open Sans',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '600',
    lineHeight: '17px',
    letterSpacing: '0.25px',
    color: '#4D4D4D',
    textAlign: 'left',
    mixBlendMode: 'normal',
    margin: '8px 0',
  },
  directions: {
    margin: '0 auto',
  },
  iconsFlex: {
    display: 'flex',
    justifyContent: 'space-around',
    margin: '5px 5px 5px 5px',
    color: '#4D4D4D',
    fontFamily: 'Open Sans',
    fontWeight: '300',
    fontSize: '14px',
    lineHeight: '16.8px',
    letterSpacing: '0.25px',
  },
  checkCircle: {
    color: '#4D7343',
  },
  highlightOff: {
    color: '#B52626',
  }
});


export default function TrailheadDetails({ feature }) {
  const { setSidebarSelection, setClickedTab } = useContext(MapContext);
  const classes = useStyles();

  const goBackToExplorer = () => {
    setSidebarSelection(null);
    setClickedTab('Explorer');
  };

  const getIcons = () => {
    return (
      <>
        {feature.attributes.FEE ? <div>Fee {feature.attributes.FEE === 'Y' ? <CheckCircleOutlineIcon className={classes.checkCircle} /> : <HighlightOffIcon className={classes.highlightOff}/>}</div> : null}
        {feature.attributes.PARKING ? <div>Parking {feature.attributes.PARKING === 'Y' ? <CheckCircleOutlineIcon className={classes.checkCircle} /> : <HighlightOffIcon className={classes.highlightOff}/>}</div> : null}
        {feature.attributes.WATER ? <div>Water {feature.attributes.WATER === 'Y' ? <CheckCircleOutlineIcon className={classes.checkCircle} /> : <HighlightOffIcon className={classes.highlightOff}/>}</div> : null}
        {feature.attributes.RESTROOM ? <div>Restroom {feature.attributes.RESTROOM === 'Y' ? <CheckCircleOutlineIcon className={classes.checkCircle} /> : <HighlightOffIcon className={classes.highlightOff}/>}</div> : null}
      </>
    );
  };

  return (
    <>
      <div className={classes.backArrowFlex} >
        <ArrowBackIcon className={classes.pointer} onClick={() => {goBackToExplorer()}}></ArrowBackIcon>
        <div className={classes.header}>{feature.attributes.POI_NAME ? feature.attributes.POI_NAME : 'Trailhead'}</div>
      </div>
      <div className={classes.iconsFlex}>
        {getIcons()}
      </div>
      { 
        feature.attributes.MANAGER ? 
          (
            <div className={classes.managerFlex}>
              <div className={classes.managerTitle}>Manager</div>
              <div className={classes.descriptionText}>{`${feature.attributes.MANAGER}`}</div>
            </div> 
          )
        : null
      }
      <div className={classes.directions}>
        <Directions trailhead={feature}/>
      </div>
    </>
  );
}
